import { createFileRoute } from '@tanstack/react-router';
import { usePageTitle } from '../../../../lib/hooks';
import { PageHeader } from '../../../../components/layout/PageHeader';
import { PageSection } from '../../../../components/layout/PageSection';
import { AmountDisplay } from '../../../../components/ui/AmountDisplay';
import { useCollectionPerformance } from '../../../../features/reports/client';
import { Button } from '../../../../components/ui/Button';
import { Input } from '../../../../components/ui/FormField';
import { DataView } from "../../../../components/ui/DataView";

export const Route = createFileRoute('/_auth/reports/operational/collections')({
  component: CollectionPerformancePage,
});

function CollectionPerformancePage() {
  usePageTitle('Collection Performance');
  const collectionperformanceQuery = useCollectionPerformance();
      const { data } = collectionperformanceQuery;
  return (
    
      <div>
        <div className="flex justify-between items-center mb-6">
                  <PageHeader title="Agent Collection Performance" />
                  <Button variant="secondary">Export CSV</Button>
                </div><div className="mb-6 flex gap-4 items-center">
                  <Input type="date" className="w-auto" />
                  <span>to</span>
                  <Input type="date" className="w-auto" />
                  <select className="border px-3 py-2 rounded">
                    <option value="">All Branches</option>
                    <option value="BR1">Branch 1</option>
                  </select>
                </div>
        <DataView query={collectionperformanceQuery}>
        {(data) => (
          <>
            <PageSection>
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-border text-left whitespace-nowrap">
                      <thead className="bg-surface-2">
                        <tr>
                          <th className="border px-4 py-2">Agent Name</th>
                          <th className="border px-4 py-2">Assigned</th>
                          <th className="border px-4 py-2">Collected</th>
                          <th className="border px-4 py-2">Amount Collected</th>
                          <th className="border px-4 py-2">Pending Amount</th>
                          <th className="border px-4 py-2">Default Rate (%)</th>
                          <th className="border px-4 py-2">Avg Days</th>
                          <th className="border px-4 py-2">EOD Rate (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((agent: any) => (
                          <tr key={agent.agentId}>
                            <td className="border px-4 py-2 font-medium">{agent.agentName}</td>
                            <td className="border px-4 py-2">{agent.assignedCount}</td>
                            <td className="border px-4 py-2">{agent.collectedCount}</td>
                            <td className="border px-4 py-2"><AmountDisplay paise={agent.collectedAmount} /></td>
                            <td className="border px-4 py-2"><AmountDisplay paise={agent.pendingAmount} /></td>
                            <td className="border px-4 py-2">{agent.defaultRate}%</td>
                            <td className="border px-4 py-2">{agent.avgDaysToCollect}</td>
                            <td className="border px-4 py-2">{agent.eodSubmissionRate}%</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </PageSection>
          </>
        )}
        </DataView>
      </div>

    );
}
